import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { handleSaveShippingSettings, shippingSettingSelector } from '@/redux/slice/shipping.slice';
import { BlockStack, Box, Checkbox } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const ShippingStatus = () => {
  const { t } = useTranslation('shippingSettings');

  const shippingSettings = useSelector(shippingSettingSelector);
  const dispatch = useDispatch();

  const handleCheckShippingZoneStatus = (checked: boolean) => {
    dispatch(handleSaveShippingSettings({ isActive: checked }));
  };

  const handleCheckShippingDatePickerStatus = (checked: boolean) => {
    dispatch(handleSaveShippingSettings({ isActiveDatePicker: checked }));
  };

  return (
    <LayoutSettings
      title={t('statusSettings.title')}
      helpText={t('statusSettings.helpText')}
      children={
        <BlockStack>
          <Checkbox
            label={t('statusSettings.turnOnShippingTitle')}
            helpText={t('statusSettings.turnOnShippingDesc')}
            checked={shippingSettings.isActive}
            onChange={handleCheckShippingZoneStatus}
          />
          {shippingSettings.isActive && (
            <Box paddingInlineStart={'600'}>
              <Checkbox
                label={t('statusSettings.turnOnDatePicker')}
                checked={shippingSettings.isActive && shippingSettings.isActiveDatePicker}
                onChange={handleCheckShippingDatePickerStatus}
              />
            </Box>
          )}
        </BlockStack>
      }
    />
  );
};

export default ShippingStatus;
